export class ValidationError extends Error {
    constructor(message: string, ...params: any[]) {
      super(...params);

      this.message = message;
    }
  }